import { render, staticRenderFns } from "./WikiDeletedPageList.vue?vue&type=template&id=82c8925a"
import script from "./WikiDeletedPageList.vue?vue&type=script&lang=ts"
export * from "./WikiDeletedPageList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports